<div id="modal-container">
  <table id="search-add-tbl">
    <tr style="height: fit-content">
      <th class="search">
        <app-lineitem-filter
          [options]="stdLineItems"
          [selectedValue]="{}"
          [selectedOptionsId]="selectedId"
          [liFilterId]="lineItemInputId"
          [disabled]="disabled"
          placeholder="&nbsp;Search Line Items"
          [showButton]="false"
          cascaderClass="li-modal-cascader"
          (onValueChange)="onLineitemChange($event)"
        ></app-lineitem-filter>
      </th>
      <th>{{ rightHeader }}</th>
    </tr>
    <tr>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.visibility]="lineItems.length ? 'visible' : 'hidden'"
          >
            <div
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="menu"
              [ngClass]="{ active: visible }"
              (nzVisibleChange)="onMenuVisibleChange($event)"
              [nzOverlayClassName]="'comp-menu-dropdown'"
              [nzBackdrop]="false"
              id="selectedItem"
            >
              {{ selectedMenuItem }}
              <i nz-icon nzType="down" style="float: right"></i>
            </div>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu class="menu-holder">
                <li
                  nz-menu-item
                  *ngFor="let data of lineItems"
                  (click)="onLiSelect($event, data)"
                >
                  {{ data.tab_full_name }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="right-heading-add" (click)="addAll()">
            <va-icon size="small" name="plus" class="icon va-icon"></va-icon>Add
            All
          </div>
        </div>
        <app-add-modal-section
          [dataToUse]="recentlyVisited"
          field="name"
          (addData)="addLi($event)"
          [maxHeight]="maxHeight"
        ></app-add-modal-section>
      </td>
      <td class="add">
        <div class="content-heading">
          <div
            class="left-heading"
            [style.color]="
              modalData.length > 2 || modalData.length < 1
                ? '#e61F00'
                : '#363636'
            "
          >
            Number of selected: {{ modalData && modalData.length }}
          </div>
          <div
            [ngClass]="[
              modalData && modalData.length
                ? 'right-heading-remove'
                : 'greyed-removeall'
            ]"
            (click)="removeAll()"
          >
            <va-icon size="small" name="close" class="icon va-icon"></va-icon
            >Remove All
          </div>
        </div>
        <app-remove-modal-section
          [dataToUse]="modalData"
          field="name"
          [maxHeight]="maxHeight"
          (removeData)="removeLi($event)"
        ></app-remove-modal-section>
      </td>
    </tr>
  </table>

  <!-- <div *nzModalFooter>
              <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
              <button
                nz-button
                nzType="primary"
                (click)="updateLineItems()"
              >
                Update
              </button>
            </div> -->
</div>
